<template>
    <dialog :open="open" class="action-dialog">
        <h3>Отменить конференцию</h3>
        <label>Причина отмены
            <textarea v-model="reason" rows="3" />
        </label>
        <label class="checkbox-label">
            <input v-model="notify" type="checkbox" />
            Уведомить участников
        </label>
        <div class="actions">
            <button class="btn btn--danger" :disabled="busy" @click="submit">
                {{ busy ? 'Отменяю…' : 'Отменить конференцию' }}
            </button>
            <button class="btn" @click="$emit('close')">Назад</button>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ open: boolean; conferenceId: () => string }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'done'): void }>();

const reason = ref('');
const notify = ref(true);
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/conferences/${props.conferenceId()}/cancel/`,
            data: { reason: reason.value, notify: notify.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}
</script>

<style scoped>
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.checkbox-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog textarea { width: 100%; box-sizing: border-box; font-size: 1rem; }
    .actions .btn { min-height: 2.5rem; }
}
</style>
